var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666664 1.33333C0.666664 0.873096 1.03976 0.5 1.5 0.5H16.5C16.9602 0.5 17.3333 0.873096 17.3333 1.33333V9.66667C17.3333 10.1269 16.9602 10.5 16.5 10.5H1.5C1.03976 10.5 0.666664 10.1269 0.666664 9.66667V1.33333ZM10.4049 5.076C10.7183 5.27183 10.7183 5.72817 10.4049 5.924L8.515 7.10521C8.18197 7.31335 7.75 7.07393 7.75 6.68121V4.31879C7.75 3.92607 8.18197 3.68665 8.515 3.89479L10.4049 5.076Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.1667C1.03976 12.1667 0.666664 12.5398 0.666664 13V14.6667C0.666664 15.1269 1.03976 15.5 1.5 15.5H16.5C16.9602 15.5 17.3333 15.1269 17.3333 14.6667V13C17.3333 12.5398 16.9602 12.1667 16.5 12.1667H1.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.c676680a6d3c5485f5ee7e7646527fdf.svg";
export { ForwardRef as ReactComponent };